import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { showModal } from '../../../actions/ModalActions';
import { createWeddingForRegistryAccountUser } from '../../../actions/WeddingActions';
import { signout } from '../../../actions/AuthActions';
import '../../../stylesheets/pages/preauth/components/FooterCtaSection.less';
import { callToAction } from '../util/LandingPageCtaHelper';

const FooterCtaSection = ({ heading, cta, onCtaClick, ctaDestination }) => (
  <div className="footer-cta-section text-center">
    <div>
      <h2>{ heading }</h2>
      <span className="lets-do-this hidden-xs">We&apos;ll make this fun and easy!</span>
      <button className="btn btn-primary btn-wide center-block footer-button" onClick={() => onCtaClick(ctaDestination)}>{cta ? `${cta}` : 'Get Started'}</button>
    </div>
  </div>
);

FooterCtaSection.propTypes = {
  heading: PropTypes.string,
  cta: PropTypes.string,
  onCtaClick: PropTypes.func.isRequired,
  ctaDestination: PropTypes.oneOf(['WEDDING_WEBSITE', 'WEDDING_GUEST_LIST', 'WEDDING_CHECKLIST']),
};

const mapStateToProps = state => (
  {
    userContext: state.user.userContext,
    weddingAccount: state.wedding.account,
  }
);

const mapDispatchToProps = dispatch => (
  {
    openModal: (modalType, modalProps, modalOptions) => {
      dispatch(showModal(modalType, modalProps, modalOptions));
    },
    showVideo: () => {
      const video = { video: 'aBqthnJ08JQ', autoplay: true };
      dispatch(showModal('VIDEO', { video, className: 'iframe-responsive', hideClose: true }, { size: 'video' }));
    },
    onCreateWeddingAccount: () => dispatch(createWeddingForRegistryAccountUser()).then(() => browserHistory.push('/wedding/manage')),
    onLogOut: () => {
      dispatch(signout()).then(() => window.location.reload());
    },
    onCtaClick: ctaDestination => dispatch(callToAction(ctaDestination)),
  }
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FooterCtaSection);



// WEBPACK FOOTER //
// ./src/pages/preauth/components/FooterCtaSection.jsx